import type React from "react";
import Seo from "../components/Seo";

const PrivacyPolicy: React.FC = () => {
  return (
    <div
      className="min-h-full"
      style={{ backgroundColor: "var(--color-complementary)" }}
    >
      <Seo
        title="Terms & Privacy Policy"
        description="Cycle Collective Saskatoon terms, conditions, and privacy policy, including our liability waiver and how we handle your information."
        path="/experience/privacypolicy"
      />
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <h1
            className="text-4xl font-bold mb-8 text-center"
            style={{ color: "var(--color-text)" }}
          >
            TERMS/CONDITIONS & PRIVACY POLICY
          </h1>
          <div
            className="space-y-6 text-lg"
            style={{ color: "var(--color-text)" }}
          >
            <div>
              <h2 className="text-2xl font-semibold mb-4">
                CYCLE COLLECTIVE - TERMS AND CONDITIONS
              </h2>
              <p>
                Welcome to Cycle Collective Saskatoon! We are so excited to have
                you join our community. By signing up for classes, purchasing
                passes, or using our facilities, you agree to the following
                terms and conditions. These are here to help ensure a safe,
                enjoyable, and respectful experience for everyone.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-2">
                Waiver and Release of Liability
              </h3>
              <p>
                Before participating in any classes or activities, all patrons
                must complete our Release of Liability, Waiver of Claims,
                Assumption of Risks, and Indemnity Agreement. This helps us keep
                everyone safe while you enjoy your time with us.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-2">Sign-Up and Passes</h3>
              <p>
                To participate in a class, you must sign up for an individual
                session, purchase a pass for multiple classes or purchase a
                membership. We're all about helping you find the best fit for
                your schedule and fitness goals!
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-2">Age Requirements</h3>
              <p>
                To join our classes, patrons must be at least 16 years old. If
                you're under 18, you'll need a parent or guardian to sign a
                consent form and verify your age. Please email
                info@cyclecollective.ca or find this on app under waivers.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-2">Dress Code</h3>
              <p>
                Comfortable fitness attire is recommended. SPD clip in cycling
                shoes are a must to ensure your safety during our cycling
                classes. We offer complimentary shoe rental service if you do
                not have your own.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-2">
                Taking Care of Equipment
              </h3>
              <p>
                Please take all personal belongings after class and we will take
                care of the clean up!
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-2">Damages</h3>
              <p>
                If any equipment or facility items are damaged during your
                visit, you may be held financially responsible for repair or
                replacement. We're all about taking care of our space, and we
                appreciate your help in doing so.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-2">
                Health and Safety First
              </h3>
              <p>
                Your health is our priority! If you feel unwell, dizzy, or
                uncomfortable during class, please stop and let your instructor
                know.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-2">Pricing</h3>
              <p>
                Our prices are subject to change, but we'll do our best to keep
                you updated. You can always check our website or ask a staff
                member for the latest info!
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-2">
                Cancellation and No-Show Policies
              </h3>
              <p>
                Life happens! We understand, but we ask that you please respect
                our cancellation policies to ensure everyone has the chance to
                enjoy classes.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-2">
                Auto-Renew Membership Terms
              </h3>
              <p>
                If you've signed up for a monthly auto-renew membership, you'll
                have agreed to additional terms when purchasing your membership.
                Don't worry—we'll make sure you have all the details!
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-2">Class Reservations</h3>
              <p>
                We recommend reserving your spot online or through our app up to
                8 days in advance. Reservations are held until class time, so
                please check in before the start to guarantee your spot. If
                you're not there 5 minutes before the scheduled start time, your
                spot might be given to someone else.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-2">Waitlist</h3>
              <p>
                If a class is full, you can join the waitlist. If a spot becomes
                available, we'll notify you by text or email. Please keep an eye
                out for notifications to avoid missing your chance to join!
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-2">Changes to Terms</h3>
              <p>
                Cycle Collective Saskatoon reserves the right to modify these
                Terms and Conditions. We'll do our best to notify you of any
                major changes, so stay tuned!
              </p>
            </div>
            <div>
              <h2 className="text-2xl font-semibold mb-4">PRIVACY POLICY</h2>
              <p>
                At Cycle Collective Saskatoon, we are committed to protecting
                your privacy. This Privacy Policy explains how we collect, use,
                and safeguard your personal information when you use our
                website, app, or services.
              </p>
              <div>
                <h3 className="text-xl font-semibold mb-2">
                  Information We Collect
                </h3>
                <p>
                  We may collect personal information such as your name, email
                  address, phone number, and payment details when you sign up
                  for classes, purchase passes, or create an account. We also
                  collect usage data through our app and website, including
                  class reservations and attendance.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">
                  How We Use Your Information
                </h3>
                <p>
                  Your information is used to process bookings, communicate with
                  you about classes and promotions, improve our services, and
                  ensure a safe environment. We do not sell or share your
                  personal data with third parties except as necessary for
                  payment processing or legal requirements.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Data Security</h3>
                <p>
                  We implement appropriate security measures to protect your
                  personal information against unauthorized access, alteration,
                  or disclosure.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Cookies</h3>
                <p>
                  Our website may use cookies to enhance your experience. You
                  can control cookie settings through your browser preferences.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Your Rights</h3>
                <p>
                  You have the right to access, update, or delete your personal
                  information. Contact us at info@cyclecollective.ca to exercise
                  these rights.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">
                  Changes to This Policy
                </h3>
                <p>
                  We may update this Privacy Policy from time to time. We will
                  notify you of any significant changes.
                </p>
              </div>
            </div>
            <div>
              <h2 className="text-2xl font-semibold mb-4">
                MEDIA WAIVER AND CONSENT
              </h2>
              <p>
                We love celebrating our community, and it's possible that people
                may capture moments from class and share them on social media.
                While we encourage this, please know that Cycle Collective will
                never post, share, or use your image, video, or testimonial
                without your explicit permission.
              </p>
            </div>
            <div>
              <h2 className="text-2xl font-semibold mb-4">
                RELEASE OF LIABILITY, WAIVER OF CLAIMS, ASSUMPTION OF RISKS &
                INDEMNITY AGREEMENT
              </h2>
              <p>
                Important: By signing this agreement, you understand that you
                are waiving certain legal rights, including the right to sue.
                Please read carefully:
              </p>
              <p>TO: Cycle Collective Saskatoon (Cycle Co)</p>
              <p>
                Assumption of Risks: I understand that participating in cycling
                classes and other activities at Cycle Collective involves
                inherent risks, including the possibility of injury or other
                physical harm. I freely accept and assume all such risks.
              </p>
              <p>
                Release of Liability: In consideration for being allowed to
                participate, I agree to waive all claims and release Cycle
                Collective, its staff, and other representatives from liability
                related to any injuries or damages that may occur while using
                the facilities or participating in any activities.
              </p>
              <p>
                Indemnity: I agree to hold Cycle Collective Saskatoon harmless
                from any claims, damages, or injuries arising from my
                participation in activities.
              </p>
              <p>
                Consent to Use Media: I understand that Cycle Collective will
                not use any photographs, video, or testimonials of me without my
                explicit written consent. I may withdraw this consent at any
                time by contacting the studio.
              </p>
              <p>
                Binding Agreement: This agreement is binding on my heirs and
                personal representatives in the event of my injury or death. I
                have read, understood, and voluntarily agreed to these Terms and
                Conditions. I acknowledge that by signing, I am waiving certain
                legal rights.
              </p>
              <p>
                Thank you for being a part of Cycle Collective Saskatoon! If you
                have any questions or concerns, feel free to reach out to us
                anytime.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
